import React from 'react';

function Footer() {
  return (
    <footer className="bg-dark text-white text-center py-4">
      <div className="container">
        <p className="mb-1">&copy; 2025 Visão Positiva. Todos os direitos reservados.</p>
        <div>
          <a href="#" className="text-white me-3">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="#" className="text-white me-3">
            <i className="bi bi-twitter"></i>
          </a>
          <a href="#" className="text-white">
            <i className="bi bi-instagram"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
